module.exports = __webpack_public_path__ + "static/media/ClinicaDelSol.6522e4d0.svg";